import React from 'react';

function PickFirstComponent() {
  const component = [ ...arguments ].find(c => !!c);;

  return (props) => <div>{ component || null}</div>;
};

export default PickFirstComponent;
